import { RawAxiosRequestConfig } from 'axios';

import {
  guestTokenQuery,
  tokenExchangeQuery,
} from '../../../index';
import { ENDEAVOR_ACCESS_TOKEN } from '@r-and-a-shared-ui/auth-client';
import { setCookieWithExpUnix } from '@r-and-a-shared-ui/utils';
import { decodeJWT } from 'aws-amplify/auth';

export function getHeader(
  xApiKey: string,
  realm: string,
  authToken: string,
): RawAxiosRequestConfig {
  const header: RawAxiosRequestConfig = {
    headers: {
      Authorization: `Bearer ${authToken}`,
      Accept: 'application/json',
      'x-api-key': xApiKey,
      Realm: realm,
    },
  };
  return header;
}

export const setEndeavorAccessToken = (value: string) => {
  const decodedToken = decodeJWT(value);
  setCookieWithExpUnix(ENDEAVOR_ACCESS_TOKEN, value, decodedToken?.payload?.exp);
};

export const getAuthToken = async ({
  isAuthenticated,
  refreshToken,
  accessToken,
  idToken,
  config } : any
) => {
  const sessionTokens = {
    accessToken,
    refreshToken,
    idToken
  };

  if (isAuthenticated) {
    const result = await tokenExchangeQuery({
      input: {
        ...config,
        ...sessionTokens
      },
    });
    setEndeavorAccessToken(result);
    return result;
  }
  else {
    const result = await guestTokenQuery({
      input: {
        ...config
      },
    });
    setEndeavorAccessToken(result);
    return result;
  }
};
